/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ProportionalSaleTypes, ProportionalSaleState } from './types';

const INITIAL_STATE: ProportionalSaleState = {
  proportional_sale: {
    total_maximo_parcelas: 0,
    valor_base: 0,
    valor_adicional: 0,
    servicos: [],
    valor_negociacao: 0,
    valor_variacao_forma_pagamento: 0,
    valor_final: 0,
    valor_parcela: '',
    payment_form: 0,
    vigencia_inicio: '',
    vigencia_fim: '',
    parcelamento: {},
    plano_id: 5,
    servico: [],
    parcelas_cartao: [],
    parcelas_boleto: [],
  },
  simulate_register: {
    plano_id: 3,
    vigencia_inicio: '',
    vigencia_fim: '',
    parcelas_boleto: {},
    parcelas_cartao: {},
    servicos: [],
    total_maximo_parcelas: 0,
    valor_adicional: 0,
    valor_base: 0,
    valor_final: 0,
    valor_negociacao: 0,
    valor_parcela: 0,
    valor_parcela_cartao: 0,
    valor_total_cartao: 0,
    valor_variacao_forma_pagamento: 0,
    payment: 'cartao',
  },
  campaign_simulation: {
    total_maximo_parcelas: 0,
    valor_base: 0,
    valor_adicional: 0,
    servicos: [],
    valor_negociacao: 0,
    valor_variacao_forma_pagamento: 0,
    valor_final: 0,
    valor_parcela: '',
    payment_form: 0,
    vigencia_inicio: '',
    vigencia_fim: '',
    parcelamento: [],
    plano_id: 0,
    servico: [],
    parcelas_cartao: [],
    parcelas_boleto: [],
  },
  request: {
    sale: {
      loading: false,
      loaded: false,
      error: false,
    },
    sale_register: {
      loading: false,
      loaded: false,
      error: false,
    },
    campaign_simulation: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<ProportionalSaleState> = (
  state = INITIAL_STATE,
  { type, dados, servico, result, payment_form, services_ids, payment },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ProportionalSaleTypes.GET_PROPORTIONAL_SALE_REQUEST:
        draft.proportional_sale = INITIAL_STATE.proportional_sale;
        draft.request.sale = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_PROPORTIONAL_SALE_SUCCESS:
        draft.proportional_sale.total_maximo_parcelas = result?.data?.data?.total_maximo_parcelas;
        draft.proportional_sale.valor_base = result?.data?.data?.valor_base;
        draft.proportional_sale.valor_adicional = result?.data?.data?.valor_adicional;
        draft.proportional_sale.servicos = result?.data?.data?.servicos;
        draft.proportional_sale.valor_negociacao = result?.data?.data?.valor_negociacao;
        draft.proportional_sale.valor_variacao_forma_pagamento =
          result?.data?.data?.valor_variacao_forma_pagamento;
        draft.proportional_sale.valor_final = result?.data?.data?.valor_final;
        draft.proportional_sale.valor_parcela = result?.data?.data?.valor_parcela;
        draft.proportional_sale.payment_form = payment_form;
        draft.proportional_sale.vigencia_inicio = result?.data?.vigencia_inicio;
        draft.proportional_sale.vigencia_fim = result?.data?.vigencia_fim;
        draft.proportional_sale.parcelamento = result?.data?.data?.parcelamento;
        draft.proportional_sale.plano_id = result?.data?.plano_id;
        draft.proportional_sale.servico = services_ids;

        draft.request.sale = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_PROPORTIONAL_SALE_FAILURE:
        draft.proportional_sale = INITIAL_STATE.proportional_sale;
        draft.request.sale = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE:
        draft.proportional_sale.total_maximo_parcelas = dados?.data?.total_maximo_parcelas;
        draft.proportional_sale.valor_base = dados?.data?.valor_base;
        draft.proportional_sale.valor_adicional = dados?.data?.valor_adicional;
        draft.proportional_sale.servicos = dados?.data?.servicos;
        draft.proportional_sale.valor_negociacao = dados?.data?.valor_negociacao;
        draft.proportional_sale.valor_variacao_forma_pagamento =
          dados?.data?.valor_variacao_forma_pagamento;
        draft.proportional_sale.valor_final = dados?.data?.valor_final;
        draft.proportional_sale.valor_parcela = dados?.data?.valor_parcela;
        draft.proportional_sale.payment_form = 10;
        draft.proportional_sale.vigencia_inicio = dados?.vigencia_inicio;
        draft.proportional_sale.vigencia_fim = dados?.vigencia_fim;
        draft.proportional_sale.parcelamento = dados?.data?.parcelamento;
        draft.proportional_sale.plano_id = dados?.plano_id;
        draft.proportional_sale.servico = servico;

        if (dados) {
          window.location.href = '/checkout';
        }
        break;
      case ProportionalSaleTypes.GET_SIMULATE_REGISTER_REQUEST:
        draft.simulate_register = INITIAL_STATE.simulate_register;

        draft.request.sale_register = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_SIMULATE_REGISTER_SUCCESS:
        draft.simulate_register.vigencia_inicio = result?.data?.vigencia_inicio;
        draft.simulate_register.vigencia_fim = result?.data?.vigencia_fim;
        draft.simulate_register.parcelas_boleto = result?.data?.data?.original?.parcelas_boleto;
        draft.simulate_register.parcelas_cartao = result?.data?.data?.original?.parcelas_cartao;
        draft.simulate_register.servicos = result?.data?.data?.original?.servicos;
        draft.simulate_register.total_maximo_parcelas =
          result?.data?.data?.original?.total_maximo_parcelas;
        draft.simulate_register.valor_adicional = result?.data?.data?.original?.valor_adicional;
        draft.simulate_register.valor_base = result?.data?.data?.original?.valor_base;
        draft.simulate_register.valor_final = result?.data?.data?.original?.valor_final;
        draft.simulate_register.valor_negociacao = result?.data?.data?.original?.valor_negociacao;
        draft.simulate_register.valor_parcela = result?.data?.data?.original?.valor_parcela;
        draft.simulate_register.valor_parcela_cartao =
          result?.data?.data?.original?.valor_parcela_cartao;
        draft.simulate_register.valor_total_cartao =
          result?.data?.data?.original?.valor_total_cartao;
        draft.simulate_register.valor_variacao_forma_pagamento =
          result?.data?.data?.original?.valor_variacao_forma_pagamento;

        draft.request.sale_register = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_SIMULATE_REGISTER_FAILURE:
        draft.simulate_register = INITIAL_STATE.simulate_register;
        draft.request.sale_register = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_REQUEST:
        draft.simulate_register = INITIAL_STATE.simulate_register;

        draft.request.sale_register = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_SUCCESS:
        draft.simulate_register.vigencia_inicio = result?.data?.vigencia_inicio;
        draft.simulate_register.vigencia_fim = result?.data?.vigencia_fim;
        draft.simulate_register.parcelas_boleto = result?.data?.data?.original?.parcelas_boleto;
        draft.simulate_register.parcelas_cartao = result?.data?.data?.original?.parcelas_cartao;
        draft.simulate_register.servicos = result?.data?.data?.original?.servicos;
        draft.simulate_register.total_maximo_parcelas =
          result?.data?.data?.original?.total_maximo_parcelas;
        draft.simulate_register.valor_adicional = result?.data?.data?.original?.valor_adicional;
        draft.simulate_register.valor_base = result?.data?.data?.original?.valor_base;
        draft.simulate_register.valor_final = result?.data?.data?.original?.valor_final;
        draft.simulate_register.valor_negociacao = result?.data?.data?.original?.valor_negociacao;
        draft.simulate_register.valor_parcela = result?.data?.data?.original?.valor_parcela;
        draft.simulate_register.valor_parcela_cartao =
          result?.data?.data?.original?.valor_parcela_cartao;
        draft.simulate_register.valor_total_cartao =
          result?.data?.data?.original?.valor_total_cartao;
        draft.simulate_register.valor_variacao_forma_pagamento =
          result?.data?.data?.original?.valor_variacao_forma_pagamento;

        draft.request.sale_register = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_FAILURE:
        draft.simulate_register = INITIAL_STATE.simulate_register;
        draft.request.sale_register = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProportionalSaleTypes.CAMPAIGN_SIMULATION_REQUEST:
        draft.campaign_simulation = INITIAL_STATE.campaign_simulation;
        draft.request.campaign_simulation = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProportionalSaleTypes.CAMPAIGN_SIMULATION_SUCCESS:
        draft.campaign_simulation = result?.data?.data?.original;
        draft.request.campaign_simulation = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProportionalSaleTypes.CAMPAIGN_SIMULATION_FAILURE:
        draft.campaign_simulation = INITIAL_STATE.campaign_simulation;
        draft.request.campaign_simulation = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProportionalSaleTypes.PAYMENT:
        draft.simulate_register.payment = payment;
        break;
      default:
    }
  });
};
export default reducer;
